import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { sendResult } from "../../../utils/helper";
import { storage } from "../../../services/config/storage";

//Style
import "./Navbar.scss";

// Consts
import { TOTAL_TIME, HINTS, LEVEL_NAMES, PAUSE_TIMER_EVENT, RESUME_TIMER_EVENT } from "../../../utils/consts";
import { Bulb, Skip } from "../../icons/Bulb";

const Navbar = (props) => {
  const history = useHistory();
  let time = storage.get.timeRemaining();
  const [timer, setTimer] = useState(time || time === 0 ? time : TOTAL_TIME);
  const [initialTime, setInititalTime] = useState(time);
  const [showHint, setShowHint] = useState(false);
  const [hintMessage, setHintMessage] = useState(false);
  const [showHintNumber, setShowHintNumber] = useState(true);
  const [hintCount, setHintCount] = useState(-1);
  const timerTimeout = useRef()

  const pauseTimer = () => {
    clearTimeout(timerTimeout.current)
  }

  const resumeTimer = () => {
    setTimer(timer => timer - 1)
  }

  useEffect(() => {
    storage.set.timeRemaining(timer);
    localStorage.setItem("hint1", 0);
    localStorage.setItem("hint2", 0);
    localStorage.setItem("totalHints", 0);
    setHintCount(-1);
    setShowHint(false);
    setShowHintNumber(true);
    window.addEventListener(PAUSE_TIMER_EVENT, pauseTimer)
    window.addEventListener(RESUME_TIMER_EVENT, resumeTimer)

    return () => {
      window.removeEventListener(PAUSE_TIMER_EVENT, pauseTimer)
      window.removeEventListener(RESUME_TIMER_EVENT, resumeTimer)
    }
  }, []);

  // Timer increase
  useEffect(() => {
    timerTimeout.current = setTimeout(() => {
      if (timer < 1) {
        getLevelNum();
        const finalObj = {
          gameData: {
            levelData: [
              {
                level: props.levelNum,
                levelName: LEVEL_NAMES[props.levelNum],
                isLevelCleared: false,
                totalTime: initialTime - timer,
                totalHintsTaken: localStorage.getItem("totalHints"),
                timeForFirstHint:
                  localStorage.getItem("totalHints") !== 0
                    ? localStorage.getItem("hint1")
                    : 0,
                timeForSecondHint:
                  localStorage.getItem("totalHints") !== 0
                    ? localStorage.getItem("hint2")
                    : 0,
              },
            ],
          },
        };
        if (time !== 0) {
          sendResult(finalObj);
        }
        history.push("/game-end");
      }
      if (!props.won) {
        setTimer(timer - 1);
        localStorage.setItem("time", timer - 1 < 0 ? 0 : timer - 1);
      }
    }, 1000);
  }, [timer]);

  const getLevelNum = () => {
    // switch (props.levelNum) {
    //   case "home":
    //     localStorage.setItem("levelsDone", 0);
    //     break;
    //   case 1:
    //     localStorage.setItem("levelsDone", 0);
    //     break;
    //   case 2:
    //     localStorage.setItem("levelsDone", 1);
    //     break;
    //   case 3:
    //     localStorage.setItem("levelsDone", 2);
    //     break;
    //   case 4:
    //     localStorage.setItem("levelsDone", 3);
    //     break;
    //   case 5:
    //     localStorage.setItem("levelsDone", 4);
    //     break;
    //   case 6:
    //     localStorage.setItem("levelsDone", 5);
    //     break;
    //   case 7:
    //     localStorage.setItem("levelsDone", 6);
    //     break;
    //   case 8:
    //     localStorage.setItem("levelsDone", 7);
    //     break;
    //   case 9:
    //     localStorage.setItem("levelsDone", 8);
    //     break;
    //   case 10:
    //     localStorage.setItem("levelsDone", 9);
    //     break;
    //   default:
    //     localStorage.setItem("levelsDone", 0);
    //     break;
    // }
  };

  const skipLevel = () => {
    const finalObj = {
      gameData: {
        levelData: [
          {
            level: props.levelNum,
            levelName: LEVEL_NAMES[props.levelNum],
            levelSkipped: true,
            isLevelCleared: false,
            totalTime: initialTime - timer,
            totalHintsTaken: localStorage.getItem("totalHints"),
            timeForFirstHint:
              localStorage.getItem("totalHints") !== 0
                ? localStorage.getItem("hint1")
                : 0,
            timeForSecondHint:
              localStorage.getItem("totalHints") !== 0
                ? localStorage.getItem("hint2")
                : 0,
          },
        ],
      },
    };
    sendResult(finalObj);
    switch (props.levelNum) {
      case "home":
        history.push("/level-dos");
        break;
      case 1:
        history.push("/level-nueve");
        break;
      case 2:
        history.push("/level-ocho");
        break;
      case 3:
        history.push("/level-seis");
        break;
      case 4:
        history.push("/level-diez");
        break;
      case 5:
        history.push("/level-tres");
        break;
      case 6:
        history.push("/level-cinco");
        break;
      case 7:
        history.push("/level-cuatro");
        break;
      case 8:
        history.push("/level-siete");
        break;
      // case 8:
      //   history.push("/level-nueve";
      //   break;
      // case 9:
      //   history.push("/level-diez";
      //   break;
      case 9:
        history.push("/game-end");
        break;
      default:
        history.push("/home");
        break;
    }
  };

  const onHintClicked = async () => {
    let hintNumber = hintCount + 1;
    if (hintNumber <= 1) {
      setHintCount(hintCount + 1);
      localStorage.setItem(`hint${hintNumber + 1}`, initialTime - timer);
      localStorage.setItem(`totalHints`, hintNumber + 1);
      setHintMessage(HINTS[props.levelNum - 1][hintNumber]);
      setShowHint(true);
    } else {
      setShowHintNumber(false);
      setHintMessage("No more hints.");
      setShowHint(true);
    }
  };

  return (
    <div className="component-navbar">
      <div className="level-num hide">Level {props.levelNum} of 9</div>
      <div className="mobile-level-num">{props.levelNum} / 9</div>
      <div className="timer-container">
        <div className="timer">
          <div
            className="fill"
            style={{ width: `${(timer / TOTAL_TIME) * 100}%` }}
          >
            {timer < 1 ? (
              <h1>Timed out</h1>
            ) : (
              <h1>
                {Math.floor(timer / 60) < 10
                  ? `0${Math.floor(timer / 60)}`
                  : Math.floor(timer / 60)}
                :{timer % 60 < 10 ? `0${timer % 60}` : timer % 60}
              </h1>
            )}
          </div>
        </div>
      </div>
      <div className="right-wrapper">
        {initialTime - timer > 20 && (
          <div>
            <div
              onClick={skipLevel}
              style={{ visibility: "none" }}
              className="skip hide"
            >
              Skip
            </div>
            <div className="mobile-skip" onClick={skipLevel}>
              <Skip color={"#d2e5ff"} />
            </div>
          </div>
        )}
        {initialTime - timer > 20 && (
          <div style={{ position: "relative" }}>
            <div onClick={onHintClicked} className="newhint hide">
              Hints
            </div>
            <div className="mobile-newhint" onClick={onHintClicked}>
              <Bulb color={"#d2e5ff"} />
            </div>
            {showHint && (
              <div className="hint-wrapper">
                <div className="hint-box">
                  <button className="x" onClick={() => setShowHint(false)}>
                    x
                  </button>
                  {showHintNumber && (
                    <button className="number">{`Hint ${
                      hintCount + 1
                    }`}</button>
                  )}
                  <p>{hintMessage}</p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
